import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import {
  Container,
  Nav,
  Row,
  Col,
  TabContent,
  TabPane,
  NavLink,
  Card,
  CardBody,
} from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import Notifications from "./Notifications/index"
import CustomEmails from "./CustomEmails/index"
import WebAlerts from "./WebAlerts/index"
import ModalComponent from "components/Modals"
import {
  deleteCommunication,
  getCustomEmails,
  getNotifications,
  getWebAlerts,
  hideDeleteCommunicationModal,
  hideSendCommunicationModal,
  openDeleteCommunicationModal,
  openSendCommunicationModal,
  sendCommunication,
} from "store/actions"
import { connect } from "react-redux"
import { SaveButton } from "components/Buttons"
import { userIsGodMode } from "utils"

const Communications = ({
  isDeleteCommunicationModalOpen,
  hideDeleteCommunicationModal,
  openDeleteCommunicationModal,
  deleteCommunication,
  getNotifications,
  getCustomEmails,
  getWebAlerts,
  isSendCommunicationModalOpen,
  openSendCommunicationModal,
  hideSendCommunicationModal,
  sendCommunication,
}) => {
  const TABS = {
    NOTIFICATIONS: 1,
    CUSTOM_EMAILS: 2,
    WEB_ALERTS: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.NOTIFICATIONS)
  const [selectedCommunication, setSelectedCommunication] = useState({})
  const [handleWebAlertTab, sethandleWebAlertTab] = useState(null)


  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const getCommunications = () => {
    getNotifications({
      o: "title",
      od: "asc",
      page: 1,
      type: "notifications",
    })
    getCustomEmails({ o: "title", od: "asc", page: 1, type: "emails" })
    getWebAlerts({})
  }
  const userIsGodModes = userIsGodMode()   

  const onDeleteCommunication = item => {
    setSelectedCommunication(item)
    openDeleteCommunicationModal()
  }

  const handleDeleteCommunication = () => {
    deleteCommunication({
      id: selectedCommunication?.id,
      callback: getCommunications,
    })
  }

  const onSendCommunication = item => {
    setSelectedCommunication(item)
    openSendCommunicationModal()
  }

  const handleSendCommunication = () => {
    sendCommunication({
      id: selectedCommunication?.id,
      callback: getCommunications,
    })
  }

  const renderBreadcrumbTitle = () => {
    switch (activeTab) {
      case 1:
        return "Notifications"
      case 2:
        return "Custom Emails"
      case 3:
        return "Web Alerts"
      default:
        return ""
    }
  }

  useEffect(() => {
    const userIsGodModes = userIsGodMode()
    console.log("userIsGodModes",userIsGodModes);
    
    if (userIsGodModes) {
      sethandleWebAlertTab(userIsGodModes)
    }
  }, [])


  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Communications" />
        <Container fluid>
          <BreadcrumbTitle
            title="Communications"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Communications",
                type: "tab",
                clickHandler: () => {
                  setActiveTab(TABS.NOTIFICATIONS)
                },
              },
              {
                title: renderBreadcrumbTitle(),
              },
            ]}
          />
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.NOTIFICATIONS)}
                      onClick={() => {
                        setActiveTab(TABS.NOTIFICATIONS)
                      }}
                    >
                      <span style={{ fontSize: "16px" }}>Notifications</span>
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.CUSTOM_EMAILS)}
                      onClick={() => {
                        setActiveTab(TABS.CUSTOM_EMAILS)
                      }}
                    >
                      <span style={{ fontSize: "16px" }}>Custom Emails</span>
                    </NavLink>
                    {handleWebAlertTab &&
                      <NavLink
                        className={markIfIsActive(TABS.WEB_ALERTS)}
                        onClick={() => {
                          setActiveTab(TABS.WEB_ALERTS)
                        }}
                      >
                        <span style={{ fontSize: "16px" }}>
                          Web Alerts(MP Only)
                        </span>
                      </NavLink>
                    }
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.NOTIFICATIONS}>
                      <Notifications
                        handleDelete={onDeleteCommunication}
                        handleSend={onSendCommunication}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.CUSTOM_EMAILS}>
                      <CustomEmails
                        handleDelete={onDeleteCommunication}
                        handleSend={onSendCommunication}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.WEB_ALERTS}>
                      <WebAlerts />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
        <ModalComponent
          open={isDeleteCommunicationModalOpen}
          onClose={hideDeleteCommunicationModal}
          title={`Delete Communication - ${selectedCommunication?.title}`}
        >
          <Row>
            <h5>Are you sure you want to delete this Communication?</h5>
          </Row>
          <Row className="mt-3">
            <Col>
              <SaveButton
                type="button"
                fullWidth={true}
                color="danger"
                content="Cancel"
                onClick={hideDeleteCommunicationModal}
              />
            </Col>
            <Col>
              <SaveButton
                type="button"
                content="Delete"
                fullWidth={true}
                onClick={handleDeleteCommunication}
              />
            </Col>
          </Row>
        </ModalComponent>
        <ModalComponent
          open={isSendCommunicationModalOpen}
          onClose={hideSendCommunicationModal}
          title={`Send Communication - ${selectedCommunication?.title}`}
        >
          <Row>
            <h5>Are you sure?</h5>
            <h5>
              Any scheduled time you have for this communication will be deleted
              after you hit "Send Now"
            </h5>
          </Row>
          <Row className="mt-3">
            <Col>
              <SaveButton
                type="button"
                fullWidth={true}
                color="danger"
                content="Cancel"
                onClick={hideSendCommunicationModal}
              />
            </Col>
            <Col>
              <SaveButton
                type="button"
                content="Send Now"
                fullWidth={true}
                onClick={handleSendCommunication}
              />
            </Col>
          </Row>
        </ModalComponent>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDeleteCommunicationModalOpen:
    state.Communications.isDeleteCommunicationModalOpen,
  isSendCommunicationModalOpen:
    state.Communications.isSendCommunicationModalOpen,
})

const mapDispatchToProps = dispatch => ({
  openDeleteCommunicationModal: () => dispatch(openDeleteCommunicationModal()),
  hideDeleteCommunicationModal: () => dispatch(hideDeleteCommunicationModal()),
  deleteCommunication: values => dispatch(deleteCommunication(values)),
  getNotifications: values => dispatch(getNotifications(values)),
  getCustomEmails: values => dispatch(getCustomEmails(values)),
  getWebAlerts: values => dispatch(getWebAlerts(values)),
  // getWebAlerts: values => {
  //   if (values && values.length > 0) { // Example condition
  //     dispatch(getWebAlerts(values));
  //   } else {
  //     console.log('No values provided, getWebAlerts not called.');
  //   }
  // },
  openSendCommunicationModal: () => dispatch(openSendCommunicationModal()),
  hideSendCommunicationModal: () => dispatch(hideSendCommunicationModal()),
  sendCommunication: values => dispatch(sendCommunication(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Communications)